/* eslint-disable @nx/enforce-module-boundaries */
import React, { useState, useEffect, useRef } from 'react';
import {
  Paper,
  Typography,
  Menu,
  MenuItem,
  Link,
  useMediaQuery,
  styled,
  Badge,
  Divider,
  IconButton,
  Button,
} from '@mui/material';
import Fade from '@mui/material/Fade';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import userProfile from '../../assets/images/profile.png';
import lightbulbImage from '../../assets/icons/lightbulb.svg';
import notificationImage from '../../assets/icons/Notification-Default.svg';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import { useAuth } from '../../authContext/useAuth';
import { useTheme } from '../../theme/ThemeContext';
import DashboardIcon from '../../iconComponent/dashboardIcon';
import TripsIcon from '../../iconComponent/tripsIcon';
import ReportsIcon from '../../iconComponent/ReportsIcon1';
import AlarmIcon from '../../iconComponent/alarmIcon';
import DirectoriesIcon from '../../iconComponent/direcoriesIcon';
import AdminIcon from '../../iconComponent/adminIcon';
import RoutesPageIcon from '../../iconComponent/RoutesPageIcon';
import VectorIcon from '../../iconComponent/vectorIcon';
import AddressIcon from '../../iconComponent/AddressIcon';
import DriverIcon from '../../iconComponent/driverIcon';
import NotificationLayout from '../../layouts/NotificationLayout';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import GeoFenceIcon from '../../iconComponent/geofenceIcon';
import PerformanceIcon from '../../iconComponent/DriverPerformanceIcon';
import DriverAlerts from '../../iconComponent/DriverAlerts';
import DriverCoaching from '../../iconComponent/DriverCoaching';
import VehicleAlerts from '../../iconComponent/Vehicle_Alerts';
import notificationSoundFile from 'packages/novous_web/src/assets/sounds/notification.mp3';
import TripCreationIcon from '../../iconComponent/tripCreationIcon';
import IgnitionBasedIcon from '../../iconComponent/IgnitionBasedIcon';
import DeviceIcon from '../../iconComponent/DeviceIcon';
import FleetgptLayout from '../../layouts/FleetgptLayout';
import HelpDeskIcon from '../../iconComponent/HelpDeskIcon';
import TroubleShootIcon from '../../iconComponent/TroubleShootIcon';
import useAxios from '../../api/useAxios';
import { API_ENDPOINTS } from '../../api/endpoints';
import useApiError from '../../api/useApiError';
import AlertToast from '../../common/components/Alert';
import GoogleTranslate from './GoogleTranslate';
import GoogleTranslateIcon from '../../../src/assets/icons/googletranslate.png';
import BroadcastIcon from '../../iconComponent/BroadcastIcon';
import DocumentIcon from '../../iconComponent/DocumentBlockIcon';
import DisplayBanner from '../../common/components/DisplayBanner';
import GroupsIcon from '@mui/icons-material/Groups';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AnalyticsIcons from '../../iconComponent/Analytics';
import SafetyIcon from '../../assets/icons/safety.svg';
import ComplianceIcon from '../../assets/icons/compliance.svg';
import ProductivityIcon from '../../assets/icons/Productivity.svg';

// Analytics view configuration
const ANALYTICS_VIEWS = {
  'Safety (Default view)': { text: 'Safety', icon: SafetyIcon },
  'Compliance (Default view)': { text: 'Compliance', icon: ComplianceIcon },
  'Productivity (Default view)': { text: 'Productivity', icon: ProductivityIcon },
};

const navItems = [
  { text: 'Dashboard', path: '/dashboard', icon: <DashboardIcon /> },
  { text: 'User Created Trips', path: '/trips', icon: <TripCreationIcon /> },
  {
    text: 'Ignition Based Trips',
    path: '/trips/ignition',
    icon: <IgnitionBasedIcon />,
  },
  { text: 'All Reports', path: '/reports-all', icon: <ReportsIcon /> },
  {
    text: 'Scheduled Reports',
    path: '/scheduled-reports',
    icon: <ReportsIcon />,
  },
  { text: 'Alarm', path: '/alarm', icon: <AlarmIcon /> },
  { text: 'My Drivers', path: '/directories/drivers', icon: <DriverIcon /> },
  {
    text: 'Driver Performance',
    path: '/driver-performance',
    icon: <PerformanceIcon />,
  },
  {
    text: 'Vehicles',
    path: '/vehicles',
    icon: <DirectoriesIcon />,
  },
  { text: 'Geofences', path: '/directories/geofences', icon: <GeoFenceIcon /> },
  { text: 'Depot', path: '/directories/depots', icon: <GroupsIcon /> },
  { text: 'Routes', path: '/trips/routes/new', icon: <RoutesPageIcon /> },
  { text: 'Addresses', path: '/trips/addresses/new', icon: <AddressIcon /> },
  { text: 'Routes', path: '/directories/routes', icon: <RoutesPageIcon /> },
  { text: 'My Drivers', path: '/trips/drivers/new', icon: <DriverIcon /> },
  { text: 'HelpDesk', path: '/support/helpdesk', icon: <HelpDeskIcon /> },
  { text: 'Analytics', icon: <AnalyticsIcons />, path: '/analytics' },
  {
    text: 'Troubleshoot',
    path: '/support/troubleshoot',
    icon: <TroubleShootIcon />,
  },
  {
    text: 'Service Manager',
    path: '/service-manager',
    icon: <HelpDeskIcon />,
  },
  {
    text: 'Addresses',
    path: '/directories/addresses',
    icon: <DirectoriesIcon />,
  },
  { text: 'Admin', path: '/admin', icon: <AdminIcon /> },
  { text: 'User Creation', path: '/admin/user-creation', icon: <AdminIcon /> },
  { text: 'Company', path: '/admin/user-creation/company', icon: <AdminIcon /> },
  { text: 'User', path: '/admin/user-creation/user', icon: <AdminIcon /> },
  { text: 'User Account', path: '/admin/user-account', icon: <ManageAccountsIcon /> },
  { text: 'Live Stream Config', path: '/admin/live-stream-config', icon: <SettingsSuggestIcon /> },
  { text: 'User Access Controls', path: '/admin/user-access-controls', icon: <AccessibilityNewIcon /> },
  { text: 'Banner Configuration', path: '/admin/create-banner', icon: <ViewCarouselIcon /> },
  { text: 'Manage Subscriptions', path: '/admin/channel-subscriptions', icon: <SubscriptionsIcon /> },
  { text: 'Manage Subscriptions', path: '/admin/internal-subscriptions', icon: <SubscriptionsIcon /> },
  { text: 'Customization', path: '/admin/customization', icon: <DashboardCustomizeIcon /> },
  // { text: "User Settings", path: "/admin/user-settings", icon: <AdminIcon /> },
  {
    text: 'Vehicle Alerts',
    path: '/alarm/vehicle-alerts',
    icon: <VehicleAlerts />,
  },
  {
    text: 'Vehicle Alerts',
    path: '/alarm/vehicle-all-alerts',
    icon: <VehicleAlerts />,
  },
  {
    text: 'Vehicle Alerts',
    path: '/alarm/vehicle-alert-details',
    icon: <VehicleAlerts />,
  },
  {
    text: 'Driver Alerts',
    path: '/alarm/driver-alerts',
    icon: <DriverAlerts />,
  },
  {
    text: 'Driver Alerts',
    path: '/alarm/driver-alert-dashboard',
    icon: <DriverAlerts />,
  },
  { text: 'Driver Coaching', path: '/driver-coaching', icon: <DriverCoaching /> },
  { text: 'Devices', icon: <DeviceIcon />, path: '/directories/devices' },
  { text: 'Broadcast', icon: <BroadcastIcon />, path: '/alarm/broadcast' },
  { text: 'Documents', icon: <DocumentIcon />, path: '/document' },
];

// Create a styled Badge for notifications
const NotificationBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#C83333',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'center',
    textTransform: 'uppercase',
    width: '14px',
    height: '14px',
    top: '4px',
    borderRadius: '4px',
  },
}));

const TopNav = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  // Destructure toggleTheme and themeName from your theme context
  const { toggleTheme, themeName } = useTheme();
  const { setShowChat } = useAuth();

  // State for profile menu dropdown
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // State to control NotificationLayout visibility
  const [showNotifications, setShowNotifications] = useState(false);
  // Initialize notifications state from localStorage
  const [notifications, setNotifications] = useState<any[]>(() => {
    const stored = localStorage.getItem('notifications');
    return stored ? JSON.parse(stored) : [];
  });

  // Initialize unreadCount state from localStorage
  const [unreadCount, setUnreadCount] = useState<number>(() => {
    const storedCount = localStorage.getItem('unreadCount');
    return storedCount ? parseInt(storedCount, 10) : 0;
  });

  // State to hold the last message received from the WebSocket
  const [lastMessage, setLastMessage] = useState<string>('');
  const [showBlurOverlay, setShowBlurOverlay] = useState(false);
  const [showGoogleTranslate, setShowGoogleTranslate] = React.useState(false);
  const iconButtonRef = useRef<HTMLButtonElement>(null);
  const translateRef = useRef<HTMLDivElement>(null);

  // Create an audioRef for the notification sound
  const audioRef = useRef<HTMLAudioElement>(new Audio(notificationSoundFile));
  // at the top of TopNav()
  const [isMuted, setIsMuted] = useState<boolean>(() => {
    const saved = localStorage.getItem('notificationMute');
    return saved ? JSON.parse(saved) : false;
  });

  // State to track the selected analytics view
  const [analyticsView, setAnalyticsView] = useState<string>(() => {
    return sessionStorage.getItem('analyticsSelectedView') || 'Safety (Default view)';
  });

  // inside TopNav
  useEffect(() => {
    // whenever isMuted flips, immediately silence or unsilence the audioRef
    audioRef.current.muted = isMuted;
    audioRef.current.volume = isMuted ? 0 : 1;
  }, [isMuted]);

  const toggleMute = () => {
    setIsMuted((prev) => {
      localStorage.setItem('notificationMute', JSON.stringify(!prev));
      return !prev;
    });
  };

  // Ref to keep track of current notifications panel state (open/closed)
  const showNotificationsRef = useRef(showNotifications);
  useEffect(() => {
    showNotificationsRef.current = showNotifications;
  }, [showNotifications]);

  // FleetGPT drawer state
  const [showFleetGPT, setShowFleetGPT] = useState(false);
  const fleetGPTRef = useRef<HTMLDivElement>(null);
  // State to hold initiate_chat API response
  const [fleetGPTChatInfo, setFleetGPTChatInfo] = useState<null | {
    user_id: string;
    conversation_id: string;
    message: string;
  }>(null);

  // -- Helper to open FleetGPT: always reset chat state --
  const openFleetGPT = () => {
    setShowChat(false);
    setShowFleetGPT(true);
  };

  // -- Helper to close FleetGPT: reset chat then hide --
  const closeFleetGPT = () => {
    setShowChat(false);
    setShowFleetGPT(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (fleetGPTRef.current && !fleetGPTRef.current.contains(event.target as Node)) {
        closeFleetGPT();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Media query for small screens (<=850px)
  const isSmallScreen = useMediaQuery('(max-width:850px)');

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();

    // Clear notifications from localStorage
    localStorage.removeItem('notifications');
    localStorage.removeItem('unreadCount');
    localStorage.removeItem('fleetgpt_chat_messages');
    // Reset the local state notifications and unread count
    setNotifications([]);
    setUnreadCount(0);

    // Proceed with logout and navigation
    await logout();
    navigate('/login');
    console.log('User logged out and notifications cleared');
  };

  const handelSetting = () => {
    handleMenuClose();
    navigate('/account-settings');
  };

  // Toggle notifications panel and reset unread count when opening
  const handleNotificationClick = () => {
    setShowNotifications((prev) => {
      const newState = !prev;
      if (!prev) {
        // Reset unread count when panel opens
        setUnreadCount(0);
      }
      return newState;
    });
  };

  // Determine active nav item based on URL path
  function findLastMatch<T>(
    arr: T[],
    predicate: (item: T, index: number, array: T[]) => boolean,
  ): T | undefined {
    for (let i = arr.length - 1; i >= 0; i--) {
      if (predicate(arr[i], i, arr)) {
        return arr[i];
      }
    }
    return undefined;
  }

  const activeNav = findLastMatch(navItems, (item) => location.pathname.startsWith(item.path)) || navItems[0];

  // Persist notifications and unread count in localStorage
  useEffect(() => {
    localStorage.setItem('notifications', JSON.stringify(notifications));
  }, [notifications]);

  useEffect(() => {
    localStorage.setItem('unreadCount', unreadCount.toString());
  }, [unreadCount]);

  // WebSocket connection and subscription
  useEffect(() => {
    if (!user?.customer_id) return;

    const fleetId = user.customer_id;
    //console.log("Connecting to notifications topic for fleetId:", fleetId);
    const socket = new SockJS(`${process.env.NX_PUBLIC_API_URL}/ws`);
    const stompclient = new Client({
      webSocketFactory: () => socket,
      onConnect: () => {
        // console.log(
        //   "Connected to websocket, subscribing to topic:",
        //   `/topic/notifications/${fleetId}`
        // );
        stompclient.subscribe(`/topic/notifications/${fleetId}`, (message: { body: string }) => {
          const parsedMessage = JSON.parse(message.body);
          setLastMessage(message.body);
          //console.log("Received message TopNav:", message.body);
          setNotifications((prev) => [parsedMessage, ...prev]);

          // Update unread count and play the notification sound if panel is closed
          // inside stompclient.subscribe(...)
          if (!showNotificationsRef.current) {
            setUnreadCount((c) => c + 1);
            if (!isMuted) {
              audioRef.current.play().catch(console.error);
            }
          }
        });
      },
    });

    stompclient.activate();

    return () => {
      stompclient.deactivate();
    };
  }, [user?.customer_id]);

  // Modified FleetGPT handlers
  // const handleOpenFleetGPT = () => {
  //   setShowBlurOverlay(true);
  // };

  const handleUnlockFleetGPT = () => {
    setShowBlurOverlay(false);
    setShowFleetGPT(true);
  };

  // Add this function inside the TopNav component
  const handleEmailSubmit = (email: string) => {
    console.log('Email submitted:', email);
    // Add your logic here, e.g., send the email to an API endpoint
  };

  const customerId = user?.customer_id;
  const userName = user?.username;
  const [toast, setToast] = useState({
    open: false,
    message: '',
    type: 'error',
  });
  // console.log("Customer ID:", customerId);
  const {
    data: CheckSubscriptionValidityData,
    error: CheckSubscriptionValidityError,
    loading: CheckSubscriptionValidityLoading,
    fetchData: fetchCheckSubscriptionValidityData,
  } = useApiError<{ createdAt: string }>(
    `${API_ENDPOINTS.fleetgpt.CHECK_FLEETGPT_SUBSCRIPTION_VALIDITY}${customerId}`,
    'GET',
  );

  const handleOpenFleetGPT = async () => {
    if (!userName) {
      console.warn('Customer ID is not available yet.');
      return;
    }

    // Call the POST API to initiate chat using query param and accept header, no body
    try {
      const response = await fetch(`http://13.203.68.232:8000/initiate_chat?user_id=${userName}`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
        },
      });
      const result = await response.json();
      console.log('Initiate Chat API response:', result);
      setFleetGPTChatInfo(result);
    } catch (error) {
      console.error('Error calling initiate_chat API:', error);
    }

    // Existing subscription validity logic
    try {
      setToast({ open: false, message: '', type: 'error' });
      const data = await fetchCheckSubscriptionValidityData(userName);

      if (data) {
        const subscriptionValidity = data.createdAt;
        const currentDateTime = new Date();
        const subscriptionExpiryDate = new Date(subscriptionValidity);

        if (subscriptionExpiryDate < currentDateTime) {
          setToast({
            open: true,
            message: 'Free Version Expired',
            type: 'error',
          });
          setTimeout(() => {
            setToast({ open: false, message: '', type: 'error' });
          }, 3000);
          return;
        }

        // If subscription is valid, open FleetGPT
        setShowFleetGPT(true);
        return;
      }

      // If no data, open FleetGPT
      setShowFleetGPT(true);
    } catch (error) {
      console.error('Error fetching FleetGPT subscription validity:', error);
    }
  };

  useEffect(() => {
    if (!showGoogleTranslate) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        iconButtonRef.current &&
        !iconButtonRef.current.contains(event.target as Node) &&
        translateRef.current &&
        !translateRef.current.contains(event.target as Node)
      ) {
        setShowGoogleTranslate(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showGoogleTranslate]);

  const [selectedFleetManagerUsername, setSelectedFleetManagerUsername] = useState(
    sessionStorage.getItem('selectedFleetManagerUsername') || '',
  );

  useEffect(() => {
    // Initial load
    const savedUsername = sessionStorage.getItem('selectedFleetManagerUsername');
    if (savedUsername) {
      setSelectedFleetManagerUsername(savedUsername);
    }

    // Listen for storage changes
    const handleStorageChange = () => {
      const newUsername = sessionStorage.getItem('selectedFleetManagerUsername') || '';
      setSelectedFleetManagerUsername(newUsername);
    };

    // Listen to both custom event and storage events
    window.addEventListener('fleetManagerChanged', handleStorageChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('fleetManagerChanged', handleStorageChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Listen for analytics view changes
  useEffect(() => {
    const handleAnalyticsViewChange = () => {
      const newView = sessionStorage.getItem('analyticsSelectedView') || 'Safety (Default view)';
      setAnalyticsView(newView);
    };

    // Listen to custom event
    window.addEventListener('analyticsViewChanged', handleAnalyticsViewChange);
    window.addEventListener('storage', handleAnalyticsViewChange);

    return () => {
      window.removeEventListener('analyticsViewChanged', handleAnalyticsViewChange);
      window.removeEventListener('storage', handleAnalyticsViewChange);
    };
  }, []);

  // State to store Chart 1614 first item data
  const [chart1614FirstItem, setChart1614FirstItem] = useState<any>(null);

  // Helper function to fetch with fallback
  const fetchWithFallback = async (url: string, options?: RequestInit): Promise<Response> => {
    try {
      const response = await fetch(url, options);
      if (!response.ok && response.status >= 500) {
        console.warn(`Primary API returned ${response.status}, attempting fallback URL...`);
        const fallbackURL = process.env.NX_PUBLIC_API_URL || 'https://backend.novusomnifleet.com'
        const fallbackResponse = await fetch(fallbackURL, options);
        if (fallbackResponse.ok || fallbackResponse.status < 500) {
          return fallbackResponse;
        }
      }
      return response;
    } catch (error) {
      console.warn('Network error detected, attempting fallback URL...');
      const fallbackURL = process.env.NX_PUBLIC_API_URL || 'https://backend.novusomnifleet.com'
      return fetch(fallbackURL, options);
    }
  };

  // Fetch All Compliance Scores (Chart ID 1614). Accept optional filters to include in payload.
  const fetchChart1614Data = async (filters?: any) => {
    try {
      const fleetId = user?.customer_id;
      if (!fleetId) {
        console.log('Fleet ID not available for chart 1614 API call');
        return;
      }

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      const endDate = new Date();

      let startDateStr = startDate.toISOString().split('T')[0];
      let endDateStr = endDate.toISOString().split('T')[0];

      if (filters?.startDate) startDateStr = filters.startDate;
      if (filters?.endDate) endDateStr = filters.endDate;

      const baseurl =
        fleetId === '685e1eec79b388464c5cd08e'
          ? process.env.NX_PUBLIC_API_URL || process.env.NX_PUBLIC_API_FALLBACK_URL
          : 'https://novusai.novusomnifleet.com';

      const params = new URLSearchParams({ start_date: startDateStr, end_date: endDateStr });

      // always include fleet_manager_id as fallback
      params.append('fleet_manager_id', String(fleetId));

      // If filters contain vehicle IDs or group, include them in the payload
      if (filters?.vehicleIds && Array.isArray(filters.vehicleIds) && filters.vehicleIds.length > 0) {
        params.append('vehicle_ids', filters.vehicleIds.join(','));
      }
      if (filters?.vehicleGroup) {
        params.append('vehicle_group', String(filters.vehicleGroup));
      }

      const url = `${baseurl}/api/v1/analytics_dashboard/api/chart_data/1614?${params.toString()}`;

      console.log('🔍 Fetching Chart 1614 from URL:', url, 'with filters:', filters);

      const response = await fetchWithFallback(url, {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      });

      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
        return;
      }

      const responseData = await response.json();

      if (responseData.data && Array.isArray(responseData.data) && responseData.data.length > 0) {
        setChart1614FirstItem(responseData.data[0]);
      }
    } catch (error) {
      console.error('❌ Error fetching Chart 1614 data:', error);
    }
  };

  // Call once on mount/user change
  useEffect(() => {
    if (user?.customer_id) {
      fetchChart1614Data();
    }
  }, [user?.customer_id]);

  // Listen for analytics filter changes and re-fetch chart 1614 with payload
  useEffect(() => {
    const handleFiltersChanged = (e: Event) => {
      const custom = e as CustomEvent;
      const filters = custom?.detail || null;
      fetchChart1614Data(filters || undefined);
    };

    window.addEventListener('analyticsFiltersChanged', handleFiltersChanged as EventListener);

    return () => {
      window.removeEventListener('analyticsFiltersChanged', handleFiltersChanged as EventListener);
    };
  }, [user?.customer_id]);

  console.log('Chart 1614 First Item:', chart1614FirstItem);

  // Helper to compute color for scores
  const getScoreColor = (key: 'safety' | 'compliance' | 'productivity', value: any) => {
    const v = Number(value);
    if (isNaN(v)) return '#6B7280';

    if (key === 'productivity') {
      if (v <= 20) return '#C83333';
      if (v <= 40) return '#F2994A';
      return '#16A34A';
    }

    // safety & compliance thresholds
    if (v <= 70) return '#C83333';
    if (v <= 90) return '#F2994A';
    return '#16A34A';
  };

  return (
    <>
      {location.pathname.endsWith('/dashboard') && <DisplayBanner />}
      <Paper
        className="flex flex-col w-full"
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.palette.selected}`,
        })}
      >
        <div className="flex justify-between items-center p-4 h-16">
          {/* Left Section */}
          <div className="flex items-center gap-2">
            {location.pathname.startsWith('/analytics') &&
              ANALYTICS_VIEWS[analyticsView as keyof typeof ANALYTICS_VIEWS] ? (
              <>
                <img
                  src={ANALYTICS_VIEWS[analyticsView as keyof typeof ANALYTICS_VIEWS].icon}
                  alt={ANALYTICS_VIEWS[analyticsView as keyof typeof ANALYTICS_VIEWS].text}
                  style={{ width: 24, height: 24 }}
                />
                <Typography variant="body1">
                  {ANALYTICS_VIEWS[analyticsView as keyof typeof ANALYTICS_VIEWS].text}
                </Typography>

                {chart1614FirstItem && (
                  <div className="flex items-center gap-3 ml-3">
                    <div className="flex items-center gap-1">
                      <div
                        style={{
                          backgroundColor: getScoreColor('safety', chart1614FirstItem.safety_score),
                          borderRadius: 6,
                          padding: '2px 8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#fff', fontWeight: 700 }}>
                          {Math.round(Number(chart1614FirstItem.safety_score) || 0)}
                        </Typography>
                      </div>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        Safety Score
                      </Typography>
                    </div>

                    <div className="flex items-center gap-1">
                      <div
                        style={{
                          backgroundColor: getScoreColor('compliance', chart1614FirstItem.compliance_score),
                          borderRadius: 6,
                          padding: '2px 8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#fff', fontWeight: 700 }}>
                          {Math.round(Number(chart1614FirstItem.compliance_score) || 0)}
                        </Typography>
                      </div>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        Compliance Score
                      </Typography>
                    </div>

                    <div className="flex items-center gap-1">
                      <div
                        style={{
                          backgroundColor: getScoreColor(
                            'productivity',
                            chart1614FirstItem.productivity_score,
                          ),
                          borderRadius: 6,
                          padding: '2px 8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#fff', fontWeight: 700 }}>
                          {Math.round(Number(chart1614FirstItem.productivity_score) || 0)}
                        </Typography>
                      </div>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        Productivity Score
                      </Typography>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {activeNav.icon}
                <Typography variant="body1">{activeNav.text}</Typography>
              </>
            )}
          </div>

          {/* Right Section */}
          <div className="flex items-center gap-4">
            {!isSmallScreen && (
              <>
                <Button
                  onClick={handleOpenFleetGPT}
                  variant="text"
                  color="primary"
                  sx={{
                    minWidth: 40,
                    height: 40,
                    padding: 0,
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                  }}
                >
                  Fleet GPT
                </Button>

                <Button
                  onClick={() => navigate('trips/new')}
                  variant="text"
                  color="primary"
                  sx={{
                    minWidth: 40,
                    height: 40,
                    padding: 0,
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                    // maxWidth: 80,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Trip Requests
                </Button>
              </>
            )}

            <div className="flex items-center gap-4">
              {/* Lightbulb icon now only displays the image without toggling theme */}
              {/* <img
                src={lightbulbImage}
                alt="Lightbulb"
                className="w-8 h-8 cursor-pointer"
                onClick={() => navigate("/knowledgeCentre")}
              /> */}

              {/* Notification Icon with Styled Badge */}
              <NotificationBadge badgeContent={unreadCount}>
                <img
                  src={notificationImage}
                  alt="Notifications"
                  className="w-8 h-8 cursor-pointer"
                  onClick={handleNotificationClick}
                  data-notification-icon
                />
              </NotificationBadge>
              <div className="relative">
                <IconButton
                  ref={iconButtonRef}
                  onClick={() => setShowGoogleTranslate((prev) => !prev)}
                  aria-label="Translate"
                  size="medium"
                  sx={{ width: 40, height: 40, marginLeft: 1 }}
                >
                  <img src={GoogleTranslateIcon} alt="Google Translate" style={{ width: 24, height: 24 }} />
                </IconButton>
                {showGoogleTranslate && (
                  <div ref={translateRef}>
                    <GoogleTranslate />
                  </div>
                )}
              </div>

              {/* Profile container */}
              <div className="flex items-center gap-2 cursor-pointer" onClick={handleMenuOpen}>
                <img src={userProfile} alt="Profile" width={32} height={32} className="rounded-full" />
                <div className="hidden sm:flex flex-col">
                  <div className="flex items-center gap-1 max-h-[21px] overflow-y-hidden">
                    <Typography variant="subtitle2" fontWeight={600}>
                      Hi, {user?.firstName}
                    </Typography>
                    <VectorIcon className="inline-block align-middle" style={{ marginTop: 12 }} />
                  </div>
                  <Typography variant="caption">
                    {selectedFleetManagerUsername ||
                      (user?.authorities === 'ROLE_FLEET_MANAGER'
                        ? 'Fleet Manager'
                        : user?.authorities === 'ROLE_SUPER_ADMIN'
                          ? 'Super Admin'
                          : 'Admin')}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          TransitionComponent={Fade}
          autoFocus={false}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              width: '180px',
              borderRadius: '8px',
              border: themeName === 'light' ? '1px solid #EFEEF7' : '1px solid #5547DD',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
              overflow: 'visible',
              mt: 1,
            },
          }}
        >
          {/* Theme toggle MenuItem (dropdown remains open when toggling) */}
          <MenuItem
            onClick={toggleTheme}
            sx={{
              color: themeName === 'dark' ? '#fff' : '#333',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: '#5547DD',
                color: '#fff',
              },
            }}
          >
            {themeName === 'dark' ? (
              <>
                <WbSunnyIcon sx={{ marginRight: 1, fontSize: 20 }} />
                <Typography variant="body2">Light Mode</Typography>
              </>
            ) : (
              <>
                <NightsStayIcon sx={{ marginRight: 1, fontSize: 20 }} />
                <Typography variant="body2">Dark Mode</Typography>
              </>
            )}
          </MenuItem>

          <Divider
            sx={{
              borderColor: themeName === 'light' ? '#EFEEF7' : '#5547DD',
            }}
          />

          {/* Logout MenuItem */}
          <MenuItem
            onClick={handleLogout}
            sx={{
              color: themeName === 'dark' ? '#fff' : '#333',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: '#5547DD',
                color: '#fff',
              },
            }}
          >
            <LogoutIcon sx={{ marginRight: 1, fontSize: 20 }} />
            <Typography variant="body2">Logout</Typography>
          </MenuItem>

          <Divider
            sx={{
              borderColor: themeName === 'light' ? '#EFEEF7' : '#5547DD',
            }}
          />

          {/* Logout MenuItem */}
          <MenuItem
            onClick={handelSetting}
            sx={{
              color: themeName === 'dark' ? '#fff' : '#333',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: '#5547DD',
                color: '#fff',
              },
            }}
          >
            <SettingsIcon sx={{ marginRight: 1, fontSize: 20 }} />
            <Typography variant="body2">Account Settings</Typography>
          </MenuItem>
        </Menu>
      </Paper>

      {/* Notification Layout Overlay */}
      {showNotifications && (
        <div
          style={{
            position: 'absolute',
            top: 70, // adjust based on your header height
            right: 20,
            zIndex: 1000,
          }}
        >
          <NotificationLayout
            onClose={() => setShowNotifications(false)}
            notifications={notifications}
            lastMessage={lastMessage}
            fleetId={user?.customer_id}
            isMuted={isMuted}
            onToggleMute={toggleMute}
          />
        </div>
      )}

      {/* FleetGPT Overlay */}
      {showFleetGPT && fleetGPTChatInfo && (
        <div ref={fleetGPTRef} style={{ position: 'absolute', top: 70, right: 20, zIndex: 1000 }}>
          <FleetgptLayout onClose={() => setShowFleetGPT(false)} chatInfo={fleetGPTChatInfo} />
        </div>
      )}

      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => {
          setToast({ open: false, message: '', type: 'error' }); // Fully reset the toast state
        }}
        type={toast.type as any}
      />
    </>
  );
};

export default TopNav;
